import { useContextSelector } from "use-context-selector"
import { WalletBalanceContext } from "../context"

export function useRefreshWalletBalances() {
  return useContextSelector(WalletBalanceContext, c => c.refresh)
}
